import { render, staticRenderFns } from "./AboutTeachers.vue?vue&type=template&id=9d13bc72&scoped=true&"
import script from "./AboutTeachers.vue?vue&type=script&lang=js&"
export * from "./AboutTeachers.vue?vue&type=script&lang=js&"
import style0 from "./AboutTeachers.vue?vue&type=style&index=0&id=9d13bc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d13bc72",
  null
  
)

export default component.exports